<template>
  <div class="header">
    <div class="children">
      <div class="left" @click="$router.push('/')">
        <img
          v-if="isHasLogo"
          :src="siteConfig.top.logoImgUrl"
          alt="logo"
          class="header__logo"
        />
      </div>
      <div class="right">
        <div class="tab">
          <div
            class="item"
            :class="active == index ? 'active' : 'unactive'"
            @click="changeTab(item, index)"
            v-for="(item, index) in navs"
            :key="item.dictValue"
          >
            {{ item.dictLabel }}
            <div class="border" v-if="active == index"></div>
          </div>
        </div>
        <template v-if="isHasLogin">
          <div class="login" @click="login" v-if="!userInfo">
            <img class="img" src="../assets/login.png" alt="" />
            登录
          </div>
          <div class="user" v-if="userInfo">
            <img class="avatar" src="../assets/user-icon.png" alt="" />
            <span class="name">{{ userInfo.nickname }}</span>
            <p class="quit" @click="quit">退出登录</p>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { getDicts } from "@/api";

const pathMap = new Map();
pathMap.set("1", "logo");
pathMap.set("2", "home");
pathMap.set("3", "competitionList");
pathMap.set("4", "course");
pathMap.set("5", "studying");
pathMap.set("6", "cooperation");
pathMap.set("7", "login");

export default {
  name: "Header",
  props: {
    siteConfig: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      active: 0,
      userInfo: null, //用户信息
      topElements: [],
    };
  },
  computed: {
    isHasLogo({ siteConfig }) {
      return (siteConfig.top?.elements || []).includes(1);
    },
    isHasLogin({ siteConfig }) {
      return (siteConfig.top?.elements || []).includes(7);
    },
    navs({ siteConfig, topElements }) {
      if (siteConfig?.top?.elements) {
        const navs = [];

        topElements.forEach((item) => {
          if (siteConfig.top.elements.includes(Number(item.dictValue))) {
            // 排除 logo 和登录注册
            if (!["1", "7"].includes(item.dictValue)) navs.push(item);
          }
        });

        return navs;
      }

      return [];
    },
  },
  created() {
    this.userInfo = JSON.parse(localStorage.getItem("USERINFO"));
    this.active = sessionStorage.getItem("tabId") || 0;

    getDicts("client_top_element").then((response) => {
      this.topElements = response.data.slice(1);
    });
  },
  methods: {
    //退出登录
    quit() {
      this.$confirm("是否退出?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        localStorage.removeItem("TOKEN");
        localStorage.removeItem("USERINFO");
        this.$router.go(0);
      });
    },
    changeTab(item, index) {
      this.active = index;
      // sessionStorage.setItem("tabId", item.id);
      this.$router.push({
        name: pathMap.get(item.dictValue),
      });
    },
    login() {
      this.$router.push({
        path: "login",

        // path: "login",
        // query:{
        //   type:1
        // }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.border {
  width: 100%;
  height: 4px;
  background: #ffffff;
  border-radius: 2px;
  /* margin-top: 7px; */
  position: absolute;
  bottom: 15px;
}
.active {
  font-weight: bold;
}
.unactive {
  font-weight: 400;
}
.user {
  display: flex;
  align-items: center;
  margin-left: 90px;
}
.avatar {
  width: 20px;
  height: 20px;
}
.name {
  font-size: 14px;
  font-weight: 400;
  color: #ffffff;
  line-height: 20px;
  margin-left: 10px;
}
.quit {
  font-size: 14px;
  font-weight: 400;
  color: #046bde;
  line-height: 20px;
  margin-left: 20px;
  cursor: pointer;
}
.header {
  width: 100%;
  color: #fff;
  font-size: 18px;
  background: #171f30;

  .left {
    height: 60px;
  }

  &__logo {
    display: block;
    width: auto;
    height: 100%;
  }
}
.children {
  width: 1178px;
  height: 80px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.tab {
  display: flex;
}
.item {
  margin: 0 15px;
  cursor: pointer;
  width: auto;
  position: relative;
  height: 80px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
.login {
  width: 126px;
  height: 40px;
  background: #046bde;
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  margin-left: 90px;
  cursor: pointer;
}
.right {
  display: flex;
  align-items: center;
}
.left {
  cursor: pointer;
}
.img {
  width: 16px;
  height: 16px;
  margin-right: 10px;
}
</style>
